import { combineReducers } from "redux";
import MenuReducer from "./reducers/MenuReducer";
import LoginReducer from './reducers/LoginReducer';
import ThemeReducer from "./reducers/ThemeReducer";
import AssetReducer from "./reducers/AssetReducer";
import LayoutReducer from './reducers/LayoutReducer';
import DeviceReducer from "./reducers/DeviceReducer";
import DeviceTypeReducer from "./reducers/DeviceTypeReducer";
import TranslationReducer from './reducers/TranslationReducer';
import LogoutReducer from './reducers/LogoutReducer';


const RootReducer = combineReducers({
    LoginReducer,
    LayoutReducer,
    DeviceReducer,
    DeviceTypeReducer,
    MenuReducer,
    TranslationReducer,
    ThemeReducer,
    AssetReducer,
    LogoutReducer
});

export default RootReducer;

